import axios, { InternalAxiosRequestConfig } from 'axios'

import { useStore } from '../store'
import { setupAutoUpdateToken } from '../util/setupToken'
import { CompanyService } from './CompanyService'
import { OnboardingService } from './OnboardingService'

const getHeader = () => {
  return {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28'
  }
}

export const requests = (host: string) => {
  const baseUrl = host
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader()
  })

  axiosInstance.interceptors.request.use(
    async (requestConfig: InternalAxiosRequestConfig) => {
      try {
        const store = useStore()
        const authTokenV2 = store.state.iframe?.authTokenV2
        requestConfig.headers['token-id'] = store.state.tokenId
        requestConfig.headers.Authorization = `Bearer ${authTokenV2}`
      } catch (e) {
        // error
      }
      return requestConfig
    }
  )
  setupAutoUpdateToken(axiosInstance)
  return axiosInstance
}

export { CompanyService, OnboardingService }
